import { init, destroy, show, updateUserId, isInitialised } from '@hotjar/webapp/features/ProductUpdates';
import { useUIState } from '@hotjar/webapp/features/Core/hooks/useUIState';

/**
 * Beamer related tracking.
 */
angular.module('hjApp.tracking').service('Beamer', function ($rootScope, $state, User, UserData) {
    let identified = false;

    /*************************
     * PRIVATE FUNCTIONS
     *************************/

    function updateBeamerUser() {
        const userId = User.get().id;

        if (!userId) return;
        updateUserId(userId);
        identified = true;
    }

    /**
     * Called every time the ui-router state changes successfully.
     */
    function onStateChange() {
        const { isAppInterfaceVisible } = useUIState.getState();

        if (!identified && UserData.loggedIn && isAppInterfaceVisible) {
            if (!isInitialised()) {
                init(updateBeamerUser);
            } else {
                updateBeamerUser();
            }
        }
    }

    this.destroy = destroy;
    this.show = show;

    /*************************
     * INITIALIZATION
     *************************/
    $rootScope.$on('$stateChangeSuccess', onStateChange);
});
